function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import PaginationVue from '@/components/PaginationVue';
import UseCasesService from '@/apps/attributes/services/use_cases_service';
import { envConfig } from '@/js/constants';
import tasks from '@/js/tasks';
export default {
  name: 'ProductizeTransformedAttributeHistory',
  components: {
    PaginationVue: PaginationVue
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      expandedRows: [],
      maxChips: 6,
      tab: null,
      useCaseLogs: [],
      tableInternalItems: [],
      internal_headers: [{
        text: 'Atributo',
        value: 'attribute_name'
      }],
      tableOutputItems: [],
      output_headers: [{
        text: 'Atributo',
        value: 'attribute_name'
      }],
      logItems: [],
      log_headers: [{
        text: 'Descripción',
        value: 'description'
      }, {
        text: 'Tipo de evento',
        value: 'event_type'
      }, {
        text: 'Ambiente',
        value: 'environment'
      }, {
        text: 'Usuario',
        value: 'user'
      }, {
        text: 'Respuesta',
        value: 'response'
      }, {
        text: 'Creación',
        value: 'creation_date'
      }],
      info: {},
      loading: false,
      keyTable: 0,
      keyTable2: 0,
      keyTable3: 0,
      pagination: {
        attributes: {
          current: 1,
          limit: envConfig.pagintaionSize,
          total: 0
        },
        output: {
          current: 1,
          limit: envConfig.pagintaionSize,
          total: 0
        },
        logs: {
          current: 1,
          limit: envConfig.pagintaionSize,
          total: 0,
          sort_by: ['creation_date'],
          sort_desc: [true]
        }
      },
      months: [{
        name: 'Enero',
        value: '01'
      }, {
        name: 'Febrero',
        value: '02'
      }, {
        name: 'Marzo',
        value: '03'
      }, {
        name: 'Abril',
        value: '04'
      }, {
        name: 'Mayo',
        value: '05'
      }, {
        name: 'Junio',
        value: '06'
      }, {
        name: 'Julio',
        value: '07'
      }, {
        name: 'Agosto',
        value: '08'
      }, {
        name: 'Septiembre',
        value: '09'
      }, {
        name: 'Octubre',
        value: '10'
      }, {
        name: 'Noviembre',
        value: '11'
      }, {
        name: 'Diciembre',
        value: '12'
      }],
      selectedMonth: null,
      selectedYear: null,
      chips: [],
      valid: false,
      isValidChips: true,
      isValidAttributes: true,
      isValidTree: true
    };
  },
  created: function created() {
    this.getLogStatus();
  },
  methods: {
    copyAwsTableName: function copyAwsTableName() {
      if (!this.awsTableName) return;
      navigator.clipboard.writeText(this.awsTableName).then(function () {
        return tasks.toast.success('Copiado');
      }).catch(function () {
        return tasks.toast.error('No se pudo copiar');
      });
    },
    getLogStatus: function getLogStatus() {
      var _this = this;
      UseCasesService.getLogStatus(this.item.automate_id).then(function (response) {
        _this.info = response.data.records;
        var raw = _this.info.input_attributes || [];
        _this.tableInternalItems = raw.map(function (a, idx) {
          var obj = typeof a === 'string' ? {
            attribute_name: a
          } : a;
          return _objectSpread(_objectSpread({}, obj), {}, {
            id: "".concat(obj.attribute_category || 'NA', "::").concat(obj.attribute_name || idx) // clave única
          });
        });
        _this.pagination.attributes.total = _this.tableInternalItems.length;
        _this.logItems = response.data.records.logs;
        _this.pagination.logs.total = _this.logItems.length;
        if (response.data.records.output_attributes !== '{}' && response.data.records.output_attributes !== null) {
          _this.tableOutputItems = response.data.records.output_attributes.map(function (x) {
            return {
              attribute_name: x
            };
          });
          _this.pagination.output.total = _this.tableOutputItems.length;
        }
        _this.keyTable++;
        _this.keyTable2++;
        _this.keyTable3++;
      });
    },
    getDateAndHours: function getDateAndHours(created) {
      var date = new Date(created);
      date.setHours(date.getHours() - 5);
      return {
        date: this.$moment(date).format('DD-MM-YYYY'),
        hour: this.$moment(date).format('HH:mm:ss')
      };
    },
    addChip: function addChip() {
      var _this2 = this;
      if (this.selectedYear && this.selectedMonth && /^\d{4}$/.test(this.selectedYear)) {
        var month_name = this.months.find(function (month) {
          return month.value === _this2.selectedMonth;
        }).name;
        var chipId = "".concat(this.selectedYear).concat(this.selectedMonth);
        var chipDisplay = "".concat(month_name, " ").concat(this.selectedYear);
        if (!this.chips.find(function (chip) {
          return chip.id === chipId;
        })) {
          this.chips.push({
            id: chipId,
            display: chipDisplay
          });
        }
        this.selectedMonth = null;
      }
      this.verificarChipsYAtributos();
      this.emitPeriodCount();
    },
    removeChip: function removeChip(index) {
      this.chips.splice(index, 1);
      this.verificarChipsYAtributos();
      this.emitPeriodCount();
    },
    verificarChipsYAtributos: function verificarChipsYAtributos() {
      this.isValidChips = this.chips.length > 0;
    },
    emitPeriodCount: function emitPeriodCount() {
      this.$emit('period-count-change', this.chips.length);
    },
    resetPeriodSelection: function resetPeriodSelection() {
      this.selectedMonth = null;
      this.selectedYear = null;
      this.chips = [];
      this.isValidChips = true;
      this.emitPeriodCount();
    },
    onSavePeriod: function () {
      var _onSavePeriod = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this3 = this;
        var isAthena, isTypeRegister, bodyBinning, body, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              isAthena = this.info.source === 'ATHENA';
              isTypeRegister = this.info.type_register === 'binning';
              console.log('this info', this.info);
              console.log('this item', this.item);
              bodyBinning = {
                period: this.chips.map(function (chip) {
                  return chip.id;
                }),
                destination_scheme: this.item.destination_scheme,
                usecase_name: this.info.use_case,
                table_name: this.info.segment,
                automate_id: this.item.automate_id,
                project_id: this.item.project_id,
                segment_id: this.item.segment_id,
                type_export_id: this.item.type_export_id,
                operator: window.userInfo.email,
                env: this.item.environment,
                origen: 'INCA',
                model: this.info.model
              };
              if (!(isTypeRegister && isAthena)) {
                _context.n = 6;
                break;
              }
              _context.p = 1;
              console.log('POST /postSaveTransformedAttributesBinning payload:', bodyBinning);
              _context.n = 2;
              return UseCasesService.postSaveTransformedAttributesPeriodBinning(bodyBinning, this.item.project_id);
            case 2:
              tasks.toast.success(this.translate('frases.successfully_registered'));
              this.$emit('close');
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error(_t);
              tasks.toast.error('Error al enviar la configuración de binning.');
            case 4:
              _context.p = 4;
              this.setShowLoading(false);
              return _context.f(4);
            case 5:
              return _context.a(2);
            case 6:
              body = {
                id: this.item.automate_id,
                period: this.chips.map(function (chip) {
                  return chip.id;
                }),
                project_id: this.item.project_id,
                segment_id: this.item.segment_id,
                type_export_id: this.item.type_export_id,
                operator: window.userInfo.email
              };
              UseCasesService.postSaveTransformedAttributesPeriod(body, this.item.project_id).then(function (response) {
                if (response && response.success) {
                  tasks.toast.success(_this3.translate('frases.successfully_registered'));
                  _this3.$emit('close');
                }
              }).catch(function (error) {
                console.error(error);
              });
            case 7:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function onSavePeriod() {
        return _onSavePeriod.apply(this, arguments);
      }
      return onSavePeriod;
    }()
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName'])), {}, {
    years: function years() {
      var currentYear = new Date().getFullYear();
      var years = [];
      for (var i = 0; i < 5; i++) {
        var year = currentYear - i;
        years.push({
          name: year.toString(),
          value: year.toString()
        });
      }
      return years;
    },
    awsTableName: function awsTableName() {
      var scheme = this.info && this.info.destination_scheme ? this.info.destination_scheme : '';
      var useCase = this.info && this.info.use_case ? this.info.use_case : '';
      var segment = this.info && this.info.segment ? this.info.segment : '';
      if (!scheme || !useCase || !segment) return '';
      return scheme + '.dlv_' + useCase + '_' + segment;
    }
  })
};